<template>
  <div class="holiday-rule-root" :class="{ 'no-sort': !(prize1 && prize1.rank) }">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.commonM.k111')" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="bg-block">
      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k230') }}</div>
        <div class="item-txt" v-if="actStartTime && actEndTime">
          1. {{ $t('lang.commonM.k231') }}:
          <br />
          <i style="color: #ff9524">{{ actStartTime }} - {{ actEndTime }}</i>
        </div>
        <div class="item-txt">2. {{ $t('lang.commonM.k202') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k233') }}</div>
        <div class="item-txt">1. {{ $t('lang.commonM.k422') }}</div>
        <!-- prettier-ignore -->
        <div class="item-tip-b">{{ $t('lang.commonM.k423') }} 1 {{ $t('lang.intimate.point') }} <i>{{ $t('lang.commonM.k424') }}</i></div>
        <!-- prettier-ignore -->
        <div class="item-tip-b">{{ $t('lang.commonM.k425') }} 3 {{ $t('lang.intimate.points') }} <i>{{ $t('lang.commonM.k424') }}</i></div>
        <div class="item-txt">2. {{ $t('lang.commonM.k426') }}</div>
        <div class="item-tip-r">{{ $t('lang.commonM.k427') }}</div>
        <div class="item-tip-r">{{ $t('lang.commonM.k200') }}</div>
        <div class="item-tip-r">{{ $t('lang.commonM.k428') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k215') }}</div>
        <div class="item-txt">1. {{ $t('lang.commonM.k429') }}</div>
        <div class="item-txt">2. {{ $t('lang.commonM.k430') }}</div>
        <div class="holiday-item" style="margin-top: 16px">
          <div class="reward-num">10 {{ $t('lang.valRuFe.points') }}</div>
          <div class="reward-coins">
            {{ milestoneData.num1Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="holiday-item">
          <div class="reward-num">20 {{ $t('lang.valRuFe.points') }}</div>
          <div class="reward-coins">
            {{ milestoneData.num2Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="holiday-item">
          <div class="reward-num">30 {{ $t('lang.valRuFe.points') }}</div>
          <div class="reward-coins">
            {{ milestoneData.num3Reward }}
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k218') }}</div>
        <div class="item-txt">1. {{ $t('lang.commonM.k431') }}</div>
        <div class="item-txt" v-if="actEndTime">
          2. {{ $t('lang.commonM.k432') }}
          <br />
          <i style="color: #ff9524">{{ actEndTime }}</i>
        </div>
        <div class="item-txt">3. {{ $t('lang.commonM.k433') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.commonM.k201') }}</div>
        <div class="item-txt">1. {{ $t('lang.commonM.k434') }}</div>
        <div class="item-txt">2. {{ $t('lang.commonM.k204') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfo } from './apidir/api.js'

export default {
  data() {
    return {
      actStartTime: '',
      actEndTime: '',
      milestoneData: {
        num1Reward: 0,
        num2Reward: 0,
        num3Reward: 0
      }
    }
  },
  methods: {
    // 获取数据
    fetchData() {
      holidayActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          if (resData.startTimestamp) {
            this.actStartTime = this.handleMoment(resData.startTimestamp, 'YYYY-MM-DD HH:mm:ss')
          }
          if (resData.endTimestamp) {
            this.actEndTime = this.handleMoment(resData.endTimestamp, 'YYYY-MM-DD HH:mm:ss')
          }

          if (resData.milestoneRewards && resData.milestoneRewards.length) {
            this.milestoneData.num1Reward = resData.milestoneRewards[0] || 0
            this.milestoneData.num2Reward = resData.milestoneRewards[1] || 0
            this.milestoneData.num3Reward = resData.milestoneRewards[2] || 0
          }
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.holiday-rule-root {
  width: 100%;
  min-height: calc(100vh - 150px);
  background: #142b76;

  .custom-nav-block {
    background: #142b76;
  }

  .bg-img {
    width: 100%;
  }

  .bg-block {
    position: relative;
    min-height: 100vh;

    padding: 20px 10px;

    .item-block {
      width: 100%;
      padding: 16px;
      margin-bottom: 16px;
      border-radius: 12px;
      background: #f4faf2;

      .item-tit {
        line-height: 22px;
        font-family: TikTokSans-Regular;
        font-weight: bold;
        font-size: 17px;
        color: #292d59;
        line-height: 22px;
      }

      .item-txt {
        width: 323px;
        line-height: 22px;
        font-family: TikTokSans-Regular;
        font-size: 15px;
        color: #284188;
        margin-top: 8px;
      }

      .item-tip-b {
        color: #292d59;
        font-family: TikTokSans-Regular;
        font-size: 17px;
        font-weight: 700;
        margin-top: 8px;
        i {
          color: #292d59;
          font-family: Roboto Flex;
          font-size: 17px;
          font-weight: 400;
        }
      }

      .item-tip-r {
        color: #292d59;
        font-family: TikTokSans-Regular;
        font-size: 15px;
        font-weight: 600;
        margin-top: 8px;
      }

      .gift-num {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        > div {
          display: flex;
          align-items: center;
          gap: 10px;

          font-family: TikTokSans-Regular;
          font-weight: 400;
          font-size: 17px;
          color: #292d59;
          line-height: 20px;

          img {
            width: 24px;
            height: 24px;
          }
        }
        > span {
          font-family: TikTokSans-Regular;
          font-weight: 400;
          font-size: 17px;
          color: #292d59;
          line-height: 20px;
          text-align: right;
        }
      }

      .holiday-item {
        font-family: TikTokSans-Regular;
        font-weight: 400;
        font-size: 15px;
        color: #292d59;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        .reward-coins {
          display: flex;
          align-items: center;
          font-weight: bold;
          .coins-icon {
            width: 16px;
            height: 16px;
            margin: 0 3px;
          }
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: Inter-Regular;
  font-weight: 600;
  color: #ffffff;
}
::v-deep .van-nav-bar__right .tit-right {
  line-height: 16px !important;
}
</style>
